import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f89596"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reports-layout" }
const _hoisted_2 = { class: "reports-sidebar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-chart-outline sidebar-icon" }),
  /*#__PURE__*/_createElementVNode("span", null, "Report Catalog")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "sidebar-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "catalog-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "catalog-item-text" }
const _hoisted_8 = { class: "catalog-item-label" }
const _hoisted_9 = { class: "catalog-item-deliverable" }
const _hoisted_10 = { class: "reports-main" }
const _hoisted_11 = {
  key: 0,
  class: "reports-empty"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-arrow-left-circle-outline reports-empty-icon" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a report from the catalog to get started.", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "report-panel-header" }
const _hoisted_16 = { class: "report-panel-title" }
const _hoisted_17 = { class: "report-panel-deliverable" }
const _hoisted_18 = { class: "report-panel-actions" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-filter-outline mr-2" }),
  /*#__PURE__*/_createTextVNode("Filters ")
], -1))
const _hoisted_20 = { class: "filters-grid" }
const _hoisted_21 = { class: "filter-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Billing Period", -1))
const _hoisted_23 = { class: "filter-field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date From", -1))
const _hoisted_25 = { class: "filter-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date To", -1))
const _hoisted_27 = { class: "filter-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sort Order", -1))
const _hoisted_29 = { class: "filter-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Output Format", -1))
const _hoisted_31 = {
  key: 0,
  class: "filter-field"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Audit Sub-Report", -1))
const _hoisted_33 = {
  key: 0,
  class: "result-panel"
}
const _hoisted_34 = { class: "result-header" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-check-circle result-icon" }, null, -1))
const _hoisted_36 = { class: "result-title" }
const _hoisted_37 = { class: "result-subtitle" }
const _hoisted_38 = {
  key: 0,
  class: "summary-chips"
}
const _hoisted_39 = { class: "chip-key" }
const _hoisted_40 = { class: "chip-val" }
const _hoisted_41 = { class: "download-buttons" }
const _hoisted_42 = {
  key: 2,
  class: "no-files-note"
}
const _hoisted_43 = {
  key: 1,
  class: "error-panel"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-alert-circle-outline" }, null, -1))
const _hoisted_45 = { class: "flex align-items-center justify-content-between" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","font-weight":"600"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-folder-outline mr-2" }),
  /*#__PURE__*/_createTextVNode("Generated Files ")
], -1))
const _hoisted_47 = {
  key: 0,
  class: "text-center py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PProgressSpinner = _resolveComponent("PProgressSpinner")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PSelectButton = _resolveComponent("PSelectButton")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.catalogLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PProgressSpinner, { style: {"width":"24px","height":"24px"} })
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.type,
                class: _normalizeClass(["catalog-item", { active: _ctx.selected && _ctx.selected.type === item.type }]),
                onClick: ($event: any) => (_ctx.selectReport(item))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["mdi catalog-item-icon", _ctx.reportIcon(item.type)])
                }, null, 2),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.label), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.deliverable), 1)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!_ctx.selected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.selected.label), 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selected.deliverable) + " · REQ-RPT", 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_PButton, {
                  label: "Generate",
                  icon: "mdi mdi-play",
                  loading: _ctx.generating,
                  disabled: !_ctx.canGenerate,
                  onClick: _ctx.generate,
                  severity: "success",
                  size: "small"
                }, null, 8, ["loading", "disabled", "onClick"])
              ])
            ]),
            _createVNode(_component_PCard, { class: "filters-card" }, {
              title: _withCtx(() => [
                _hoisted_19
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_PDropdown, {
                      modelValue: _ctx.filters.billing_period_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.billing_period_id) = $event)),
                      options: _ctx.billingPeriods,
                      optionLabel: "name",
                      optionValue: "id",
                      placeholder: "Select period…",
                      showClear: "",
                      class: "w-full"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_PInputText, {
                      modelValue: _ctx.filters.date_from,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.date_from) = $event)),
                      type: "date",
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_PInputText, {
                      modelValue: _ctx.filters.date_to,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.date_to) = $event)),
                      type: "date",
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_PSelectButton, {
                      modelValue: _ctx.filters.sort_order,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.sort_order) = $event)),
                      options: _ctx.sortOrderOptions,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_PSelectButton, {
                      modelValue: _ctx.filters.format,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.format) = $event)),
                      options: _ctx.formatOptions,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  (_ctx.selected.type === 'audit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_PDropdown, {
                          modelValue: _ctx.filters.audit_sub_type,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.audit_sub_type) = $event)),
                          options: _ctx.auditSubTypes,
                          optionLabel: "label",
                          optionValue: "value",
                          class: "w-full"
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            (_ctx.lastResult)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.lastResult.title), 1),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.lastResult.subtitle) + " · " + _toDisplayString(_ctx.lastResult.row_count.toLocaleString()) + " rows ", 1)
                    ])
                  ]),
                  (Object.keys(_ctx.lastResult.summary || {}).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastResult.summary, (v, k) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: k,
                            class: "summary-chip"
                          }, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.formatKey(k)), 1),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(v ?? '—'), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_41, [
                    (_ctx.lastResult.pdf_file)
                      ? (_openBlock(), _createBlock(_component_PButton, {
                          key: 0,
                          label: "Download PDF",
                          icon: "mdi mdi-file-pdf-box",
                          severity: "danger",
                          size: "small",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadFile(_ctx.lastResult.pdf_file)))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.lastResult.xlsx_file)
                      ? (_openBlock(), _createBlock(_component_PButton, {
                          key: 1,
                          label: "Download XLSX",
                          icon: "mdi mdi-microsoft-excel",
                          severity: "success",
                          size: "small",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadFile(_ctx.lastResult.xlsx_file)))
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.lastResult.pdf_file && !_ctx.lastResult.xlsx_file)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, " No output files were generated (check server logs). "))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (_ctx.showFilesList)
        ? (_openBlock(), _createBlock(_component_PCard, {
            key: 2,
            class: "files-card mt-4"
          }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_PButton, {
                  label: "Refresh",
                  icon: "mdi mdi-refresh",
                  size: "small",
                  severity: "secondary",
                  text: "",
                  onClick: _ctx.loadFilesList
                }, null, 8, ["onClick"])
              ])
            ]),
            content: _withCtx(() => [
              (_ctx.filesLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(_component_PProgressSpinner, { style: {"width":"24px","height":"24px"} })
                  ]))
                : (_openBlock(), _createBlock(_component_PDataTable, {
                    key: 1,
                    value: _ctx.generatedFiles,
                    rows: 15,
                    rowsPerPageOptions: [15, 30, 100],
                    paginator: "",
                    size: "small",
                    alwaysShowPaginator: false,
                    stripedRows: "",
                    showGridlines: true
                  }, {
                    empty: _withCtx(() => [
                      _createTextVNode("No report files found.")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_PColumn, {
                        field: "filename",
                        header: "Filename"
                      }),
                      _createVNode(_component_PColumn, {
                        field: "size_kb",
                        header: "Size (KB)"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createTextVNode(_toDisplayString(data.size_kb) + " KB", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_PColumn, { header: "Download" }, {
                        body: _withCtx(({ data }) => [
                          _createVNode(_component_PButton, {
                            label: data.filename.endsWith('.pdf') ? 'PDF' : 'XLSX',
                            icon: data.filename.endsWith('.pdf') ? 'mdi mdi-file-pdf-box' : 'mdi mdi-microsoft-excel',
                            severity: data.filename.endsWith('.pdf') ? 'danger' : 'success',
                            size: "small",
                            text: "",
                            onClick: ($event: any) => (_ctx.downloadFile(data.filename))
                          }, null, 8, ["label", "icon", "severity", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}